import React, { useMemo, useCallback } from 'react';
import { CForm, CFormLabel, CFormInput, CRow, CCol, CButton, CFormTextarea } from '@coreui/react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { useConvertToLocalTime } from 'src/components/store/useConvertToLocalTime';
import PermissionsNoPage, { Permissions } from 'src/components/Permissions';

const urlApi = '/service_order_histories';

export async function LoaderServiceOrdersView({ params }) {
  if (!params?.pid) {
    return false;
  }

  const res = await AxiosInstance.get(`${urlApi}/${params.pid}`).then((response) => response);
  return res;
}

const ServiceOrdersView = ({ user_data }) => {
  // if (!Permissions(user_data, 'Applications', 'EDIT_APPLICATIONS')) {
  //   return <PermissionsNoPage />;
  // }
  const { data } = useLoaderData();
  const navigate = useNavigate();

  const formatValue = useCallback((value) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'boolean') return value ? 'Так' : 'Ні';
    return String(value);
  }, []);

  const fields = useMemo(() => {
    if (!data) return [];

    const result = [
      { key: 'id', label: 'ID', value: formatValue(data.id) },
      { key: 'name', label: 'Назва заявки', value: formatValue(data.name) },
      {
        key: 'personalAccount',
        label: 'Особовий рахунок',
        value: formatValue(data.personalAccount?.number),
      },
      { key: 'status', label: 'Статус', value: formatValue(data.status) },
      { key: 'type', label: 'Тип', value: formatValue(data.type) },
      {
        key: 'dateEntered',
        label: 'Дата створення',
        value: data.dateEntered ? useConvertToLocalTime(data.dateEntered) : '',
      },
      {
        key: 'dateModified',
        label: 'Дата зміни',
        value: data.dateModified ? useConvertToLocalTime(data.dateModified) : '',
      },
      { key: 'idCrm', label: 'ID CRM', value: formatValue(data.idCrm) },
    ];

    if (data.pdf) {
      result.push({
        key: 'pdf',
        label: 'PDF',
        value: data.pdf,
      });
    }

    if (data.description) {
      result.push({
        key: 'description',
        label: 'Опис',
        value: formatValue(data.description),
        multiline: true,
      });
    }

    if (data.message) {
      result.push({
        key: 'message',
        label: 'Повідомлення',
        value: formatValue(data.message),
        multiline: true,
      });
    }

    if (data.commentar) {
      result.push({
        key: 'commentar',
        label: 'Коментар',
        value: formatValue(data.commentar),
        multiline: true,
      });
    }

    return result;
  }, [data, formatValue]);

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  if (!data) {
    return (
      <CForm className="mb-3">
        <p className="text-medium-emphasis mb-3">Дані заявки відсутні.</p>
        <CButton color="secondary" variant="outline" onClick={handleBack}>
          Повернутись
        </CButton>
      </CForm>
    );
  }

  return (
    <CForm className="mb-3">
      <CRow className="g-3">
        {fields.map(({ key, label, value, multiline }) => (
          <CCol md={multiline ? 12 : 6} key={key}>
            <CFormLabel>{label}</CFormLabel>
            {multiline ? (
              <CFormTextarea value={value} disabled readOnly rows={4} />
            ) : (
              <CFormInput type="text" value={value} disabled readOnly autoComplete="off" />
            )}
          </CCol>
        ))}
      </CRow>
      <div className="d-flex justify-content-start mt-4">
        <CButton color="secondary" variant="outline" onClick={handleBack}>
          Повернутись
        </CButton>
      </div>
    </CForm>
  );
};

export default ServiceOrdersView;


